export interface CountryPolicyCopy {
  code: string;
  displayName: string;
  legalReference: string;
}

export const SUPPORTED_COUNTRY_POLICY_COPY: CountryPolicyCopy[] = [
  {
    code: 'ZA',
    displayName: 'South Africa',
    legalReference: 'Basic Conditions of Employment Act (BCEA)',
  },
  {
    code: 'GB',
    displayName: 'United Kingdom',
    legalReference: 'Employment Rights Act 1996 and Working Time Regulations 1998',
  },
  {
    code: 'IN',
    displayName: 'India',
    legalReference: 'Shops and Establishments Act (state-specific) and applicable labour codes. Public holidays follow the South Africa calendar.',
  },
];

export const LEAVE_POLICY_COPY = {
  familyDefinition:
    'For when your child is born or sick, or when a close family member dies. Family leave limits are country-specific and shown in policy reports.',
  sickDefinition:
    'When you are unable to work due to illness or injury. Sick leave caps and evidence rules are country-specific. Your manager or HR may request a note if your leave includes a Monday, Friday, or a day next to a public holiday.',
  parentalDefinition:
    'Parental leave for birth, adoption, or surrogacy. Entitlement rules are policy-based and may vary by country and employment context. Does not count toward annual leave.',
  supportingDocumentsSummary:
    'Sick leave evidence rules depend on your country policy (for example, certificate requirements for longer or repeated sick leave).',
};

export function buildLegalContextSummary(): string {
  const legalBits = SUPPORTED_COUNTRY_POLICY_COPY.map(
    (item) => `${item.displayName}: ${item.legalReference}`
  );
  return `Leave rules are country-specific. ${legalBits.join('; ')}.`;
}
